export enum EnvTypes {
  Staging = 'staging',
  Production = 'prod',
  Qa = 'qa',
  Dev = 'dev',
  Poc = 'poc',
}

export enum ApplicantTypes {
  PrimaryApplicant = 'applicant1',
  CoApplicant = 'applicant2',
}

export enum StipulationTypes {
  Income = 'income',
  Residence = 'residence',
  Identity = 'identity',
  Insurance = 'insurance',
  SSN = 'ssn',
}
